<!-- DateSelector.vue -->
<template>
  <div style="display:flex;justify-content: space-evenly;margin-left:20px;"  class="max_x">
    <div style="display:flex;flex-direction: column;width:150px;cursor: pointer;">
      <span @click="handleClick('today')" style="padding:5px 0px">今天</span>
      <span @click="handleClick('thisWeek')" style="padding:5px 0px">本周</span>
      <span @click="handleClick('thisMonth')" style="padding:5px 0px">当月</span>
      <span @click="handleClick('thisYear')" style="padding:5px 0px">当年</span>
    </div>
    <div style="display:flex;flex-direction: column;width:150px;cursor: pointer;">
      <span @click="handleClick('yesterday')" style="padding:5px 0px">昨天</span>
      <span @click="handleClick('lastWeek')" style="padding:5px 0px">上周</span>
      <span @click="handleClick('lastMonth')" style="padding:5px 0px">上月</span>
      <span @click="handleClick('lastYear')" style="padding:5px 0px">去年</span>
    </div>
  </div>
</template>

<script>

export default {
  data() {

    return {

    }
  },


  methods:{

     handleClick(option) {
      this.$emit('handle-click', option);
    },
  }
}

</script>

<style lang="less" scoped>
  .max_x div span:hover {
    background:#ededed
  }

</style>



// WEBPACK FOOTER //
// src/components/tanchu.vue